import { render, staticRenderFns } from "./Home.data-manager-af-prt-pid.vue?vue&type=template&id=a8a70408&scoped=true&"
import script from "./Home.data-manager-af-prt-pid.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager-af-prt-pid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a70408",
  null
  
)

export default component.exports